import { jsx } from "react/jsx-runtime";
const SvgImages = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M22 18V2H6V18H22ZM11 12L13.03 14.71L16 11L20 16H8L11 12ZM2 6V22H18V20H4V6H2Z", fill: "currentColor" }) });
export default SvgImages;
